export class PasswordResetViewModel {
    username: string;
    password: string;
    confirm: string;
    token: string;
  }
